import { Fragment, useCallback } from 'react';

import { useFormContext } from 'react-hook-form';
import { MultiValue } from 'react-select';

import { Divider } from '@hsp/react-component-library';

import { VirtualSelect } from 'components/select';
import { useFetchStates } from 'hooks/queries';
import { ExcludeIncludeButtonGroup } from 'pages/audience/shared';
import { ISelectedFilter, SearchType } from 'types/api/audience';
import { ExcludeInclude } from 'types/api/common';
import { IState } from 'types/api/states';
import { s } from 'utilities/strings';

const formName = `${SearchType.Locations}.states`;

const StateSelector = () => {
  const { getValues, setValue } = useFormContext();
  const { data: states, isLoading } = useFetchStates();

  const getValue = useCallback(() => {
    const current = getValues(formName) as ISelectedFilter<IState>;

    return current;
  }, [getValues]);
  const getIncludeExclude = useCallback(() => {
    return getValue()?.type;
  }, [getValue]);
  const getStateValue = useCallback(() => {
    const current = getValue();

    return (states ?? []).filter((state) => {
      return (current?.filters ?? []).find((item) => state.code === item.code);
    });
  }, [getValue, states]);
  const handleOnExcludeIncludeClick = useCallback(
    (type: ExcludeInclude) => {
      const current = getValue();

      setValue(formName, { ...current, type });
    },
    [getValue, setValue]
  );
  const handleOnStateChanged = useCallback(
    (options: MultiValue<IState>) => {
      const current = getValue();

      setValue(formName, { ...current, filters: options });
    },
    [getValue, setValue]
  );

  return (
    <Fragment>
      <div className="d-flex justify-content-end">
        <ExcludeIncludeButtonGroup
          onToggle={handleOnExcludeIncludeClick}
          value={getIncludeExclude()}
        />
      </div>
      <div className="mb-3">
        <Divider>{s(['Site.Location'], { plural: true })}</Divider>
      </div>
      <VirtualSelect
        closeMenuOnSelect={false}
        getOptionLabel={({ code, name }) => `${name} (${code})`}
        getOptionValue={({ code }) => code}
        isClearable
        isDisabled={isLoading}
        isLoading={isLoading}
        isMulti
        onChange={handleOnStateChanged}
        options={states}
        placeholder={s(['Site.Select', 'Site.State'], { plural: true })}
        value={getStateValue()}
      />
    </Fragment>
  );
};

export default StateSelector;
